<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div style="margin-top: 2%">
       

        <v-card>
            <v-card-title>

                <v-text-field
                        v-model="search"
                        append-icon="mdi-magnify"
                        label="Rechercher un pharmacien ..."
                        single-line
                        hide-details
                ></v-text-field>
            </v-card-title>
            <v-data-table
                                   :headers="headers"
                                   :items="userpharmas"
                                   :search="search"
                                   sort-by="name"
                                   class="elevation-1"
                                   :loading="userpharmas==undefined" loading-text="Chargement en cours...">

 <template v-slot:item.created_at="{item}">
                                        {{ getformatDate(item.created_at)}}
                                    </template>


                               <template v-slot:no-data>
                                   <v-btn color="default" @click="initialize">Actualiser</v-btn>
                               </template>
                           </v-data-table>
        </v-card>

        <v-snackbar
                v-model="snackbar"
                timeout="2000"
        >
            {{ textSnack }}

            <template v-slot:action="{ attrs }">
                <v-btn
                        color="blue"
                        text
                        v-bind="attrs"
                        @click="snackbar = false"
                >
                    Fermer
                </v-btn>
            </template>
        </v-snackbar>


    </div>
</template>

<script>
    import {mapState} from "vuex";
    import helpers from "../mixins/helpers";

     export default {
        name: "User",
        mixins:[helpers(this)],
        data() {
            return {
                submitting: false,
                valid: true,
                lazy: false,
                errors:undefined,
                search: '',
                dialog: '',
                id: undefined,
                snackbar: false,
                user: JSON.parse(localStorage.getItem("user")),
                textSnack: '',
                show1: false,
                headers: [
                    {
                        text: 'Nom complet',
                        align: 'start',
                        sortable: true,
                        value: 'name',
                    },
                    {text: 'Email', value: 'email'},
                    {text: 'Pharmacie', value: 'relation.nom'},
                     {text: 'Date', value: 'created_at'},
                ],
                editedIndex: -1,
                editedItem: {
                    password: '',
                    email: '',
                    name: '',
                    _id: 0,
                    created_at: 0,
                },
                defaultItem: {
                    password: '',
                    email: '',
                    name: '',
                    _id: 0,
                    created_at: 0,
                },
                nameRules: [
                    v => !!v || 'Nom requis',
                    // v => (v && v.length <= 10) || 'Name must be less than 10 characters',
                ],
                emailRules: [
                    v => !!v || 'Email requis',
                ]
                ,
                passwordRules: [
                   v => !!v || 'Mot de passe requis',
                ]

            }
        }
        ,
        computed: {
            formTitle() {
                return this.editedIndex === -1 ? "Nouvel utilisateur" : "Mise à jour"
            }
            ,
            ...mapState('users/', ['userpharmas'])

        }
        ,
        mounted() {
           
            this.$store.dispatch('users/getByType',"pharmacie").then(response => {
                window.console.log('users', response)
            });
        }
        ,
        watch: {
            dialog(val) {
                val || this.close()
            },
        }
        ,
        methods: {
            initialize() {

            },
            close() {
                this.dialog = false;
                this.$nextTick(() => {
                    this.editedItem = Object.assign({}, this.defaultItem);
                    this.editedIndex = -1
                });
                this.$refs.form.reset()
            },
            checkisDashboard() {
                this.$emit('checkisDashboard', true);
            }
        },
        created() {
            this.checkisDashboard();
            this.initialize()
        }

    }
</script>

<style scoped>

</style>